import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import CreateTracker from "./pages/CreateTracker";
import TrackerDetail from "./pages/TrackerDetail";
import Notifications from "./pages/Notifications";
import Settings from "./pages/Settings";
import DropDeal from "./pages/DropDeal";
import DealLocker from "./pages/DealLocker";
import CreateWatch from "./pages/CreateWatch";
import UploadPurchase from "./pages/UploadPurchase";

// Protected Route wrapper
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

// App Router with session_id detection
function AppRouter() {
  const location = useLocation();
  
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route 
        path="/dashboard" 
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/drop-deal" 
        element={
          <ProtectedRoute>
            <DropDeal />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/locker/:userId" 
        element={
          <ProtectedRoute>
            <DealLocker />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/create-tracker" 
        element={
          <ProtectedRoute>
            <CreateTracker />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/tracker/:trackerId" 
        element={
          <ProtectedRoute>
            <TrackerDetail />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/notifications" 
        element={
          <ProtectedRoute>
            <Notifications />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/settings" 
        element={
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/create-watch" 
        element={
          <ProtectedRoute>
            <CreateWatch />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/upload-purchase" 
        element={
          <ProtectedRoute>
            <UploadPurchase />
          </ProtectedRoute>
        } 
      />
      {/* Redirects */}
      <Route path="/categories" element={<Navigate to="/dashboard" replace />} />
      <Route path="/search" element={<Navigate to="/dashboard" replace />} />
      <Route path="/profile/:userId" element={<Navigate to="/locker/:userId" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="noise-bg min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster 
            position="top-right" 
            toastOptions={{
              style: {
                background: '#121214',
                border: '1px solid rgba(255,255,255,0.1)',
                color: '#FAFAFA',
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
